import { Expo } from "gsap";
import * as HLF from "html-living-framework";
import { Ease } from "../core/Animatable";
import { texture } from "../core/AssetHelpers";
import {BaseButton, HoverableButton, TextureButton} from "../core/Button";
import { Container } from "../core/Container";
import {Callback, Mix} from "../core/Reflection";
import { Sprite } from "../core/Sprite";
import {TransformBackup} from "../core/TransformBackup";
import * as PlanterGameModel from "../data/PlanterGameModel";
import {TrashType} from "../data/TrashType";
import { Button } from "./Button";
import { SplashPlayButton } from "./SplashPlayButton";

export class Planter extends Button {

    public planted: boolean = false;
    public downDisabled = true;
    public hoverDisabled = true;
    public downScale = 1;
    protected plant = new Sprite();

    constructor() {
        super();
        this.buttonMode = false;
    }

    public Plant(pPlantName: string) {
        this.plant.y = -this.sprite.height * this.anchor.y;
        this.plant.setLayoutTexture(pPlantName, 0.5, 1);
        this.visuals.addChild(this.plant);
        this.plant.scale.set(1 / this.scale.y); // bit of a hack
        // this.interactive = false;
        this.planted = true;
        HLF.Application.instance.audio.play("planter-party-plant-grow", 1, false, HLF.AudioCategory.SFX);
        this.plant.scaleFrom(0, 0.5, Expo.easeInOut, () => {
            this.hoverDisabled = false;
            PubSub.publishSync("planter planted", this);
        });
    }
}
